<template>
  <layout-basic>


    <h3 class="title is-4">New test job</h3>

    <form action="">

      <section>
        <b-steps>

          <b-step-item step="1" label="General" :clickable="isStepsClickable">
            <test-job-general/>
          </b-step-item>

          <b-step-item step="2" label="Test type" :clickable="isStepsClickable">
            <test-job-config/>
          </b-step-item>

          <b-step-item step="3" label="Validator" :clickable="isStepsClickable">
            <test-job-validator/>
          </b-step-item>


          <b-step-item step="4" label="Alert" :clickable="isStepsClickable" disabled>
            <test-job-alert/>
          </b-step-item>
          <br>
          <br>
          <template
            slot="navigation"
            slot-scope="{previous, next}">
            <b-button
              outlined
              :disabled="previous.disabled"
              class="is-pulled-left"
              @click.prevent="previous.action">
              Previous

            </b-button>

            <b-button
              v-if="!next.disabled"
              outlined
              :disabled="next.disabled"
              class="is-pulled-right"
              @click.prevent="next.action">
              Next
            </b-button>

            <button v-if="next.disabled" class="button is-primary is-pulled-right" @click="formSubmit">Save</button>
          </template>
        </b-steps>
      </section>
      <br>
      <br>
      <br>
      <br>
    </form>
  </layout-basic>
</template>

<script>

import TestJobGeneral from '@/components/TestJob/Form/General'
import TestJobAlert from '@/components/TestJob/Form/Alert'
import TestJobValidator from '@/components/TestJob/Form/Validator'
import TestJobConfig from '@/components/TestJob/Form/TestType'
import LayoutBasic from '@/layouts/LayoutBasic'
import TestJobsService from "@/services/TestJobsService";

export default {
  name: 'NewTestJob',

  components: {
    LayoutBasic,
    TestJobGeneral,
    TestJobAlert,
    TestJobValidator,
    TestJobConfig,
  },

  data() {
    return {
      isStepsClickable:true,
    }
  },

  created() {
    this.$store.dispatch('testJob/setProjectId', this.$route.params.projectId);
  },

  methods: {
    formSubmit(e) {
       e.preventDefault()
       const requestData = this.$store.getters['testJob/testJobRequestData'];
       TestJobsService.new(requestData)
        .then(response => {
          this.$router.push({path: '/project/' + this.$route.params.projectId})
        })
    },
  }
}
</script>
